import store from "../../../../../store";
import { DomainRegistry } from "../../../../../domain";
import { Directory } from "../../../../../domain/drawing";
import { FormatReference } from "../../../../../domain/format";
import { ITreeSource, IEditTreeSource } from ".";
import { IConfiguration } from "../../../../../domain/configuration";

export class DepartmentFavoriteFormatTreeSource implements ITreeSource<FormatReference>, IEditTreeSource<FormatReference> {
  constructor(private _departmentId: string, private _shouldIgnoreChained: boolean, private _shouldIncludeReferenceableGroupFormats: boolean) {
  }

  private readonly config = store.getters.configuration as IConfiguration;
  public entityName: string = this.config.wording.common.departmentAsShort + "頻用" + this.config.wording.format.name + "情報";

  getTree(): Promise<Directory<string, FormatReference>[]> {
    if (this._departmentId === null) {
      return new Promise<Directory<string, FormatReference>[]>((e) => e());
    }
    const repository = DomainRegistry.format.getFormatRepository();
    return repository.getDepartmentFavoriteFormats(this._departmentId, this._shouldIgnoreChained, this._shouldIncludeReferenceableGroupFormats);
  }

  saveEditTree(treeSource: Directory<string, FormatReference>[]): Promise<void> {
    const repository = DomainRegistry.format.getFormatRepository();
    return repository.setDepartmentFavoriteFormats(this._departmentId, treeSource);
  }

  get managementKey(): string {
    return this._departmentId;
  }
}
